import ApiConstant from "../../constants/api.constants";
import api from "../api";

const getAllBulls = async () => {
  try {
    const result = await api.get(ApiConstant.getAllBulls);
    return result?.data ?? [];
  } catch (error) {
    console.error("Error fetching all bulls:", error);
    return [];
  }
};

const getAllBullsForPairing = async () => {
  try {
    const result = await api.get(ApiConstant.getAllBullsForPairing);
    return result?.data ?? [];
  } catch (error) {
    console.error("Error fetching bulls for pairing:", error);
    return [];
  }
};

const addBull = async (bullData: any) => {
  try {
    const result = await api.post(ApiConstant.addBull,bullData);
    return result.data; 
    // return result?.data ?? null;
  } catch (error) {
    console.error("Error adding bull:", error);
    return null;
  }
};


const getAllMUPlants = async () => {
  try {
    const result = await api.get(ApiConstant.getAllMUPlants);
    const data = result?.data ?? [];
    return Array.isArray(data) ? data : data?.data ?? [];
  } catch (error) {
    console.error("Error fetching manufacturing units:", error);
    return [];
  }
};
const deleteBull = async (userId: number) => {
  try {
    const result = await api.delete(ApiConstant.deleteDesiriBull, {
      params: { userId },
    });
    return result?.data ?? { isSuccess: false, message: "Unknown error" };
  } catch (error) {
    console.error(`Error deleting Bull ${userId}:`, error);
    return { isSuccess: false, message: "Error deleting Bull" };
  }
};
const updateBull = async (bullData: any) => {
  try {
    const response = await api.put(ApiConstant.updateDesiriBull, bullData);
    return response.data; // assuming API returns { isSuccess, message, data }
  } catch (error: any) {
    console.error("Error updating Desiri bull:", error);
    return {
      isSuccess: false,
      message: error?.response?.data?.message || "Error updating Desiri bull",
    };
  }
};
const desiriBullService = {
  getAllBulls,
  getAllBullsForPairing,
  addBull,
  getAllMUPlants,
  deleteBull,
  updateBull
};

export default desiriBullService;
